/* Stickly.it - hero a scorrimento + configuratore adesivi (v5.2: maniglie agli angoli) */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function isSmall() { return window.innerWidth < 1000; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ================= HERO ================= */
  var IMG = { w: 2752, h: 1536, sx: 0.319, sy: 0.176, sw: 0.359, sh: 0.645 };

  /* altezza della parte di intestazione che resta fissa in alto (Horizon: header sticky, annuncio no) */
  function stickyHeaderHeight() {
    var hg = document.getElementById('header-group');
    if (!hg) return 0;
    var h = 0;
    var nodes = hg.querySelectorAll('.shopify-section, .header-section, #header-component');
    Array.prototype.forEach.call(nodes, function (n) {
      var p = getComputedStyle(n).position;
      if (p === 'sticky') h = Math.max(h, n.getBoundingClientRect().height);
    });
    if (!h) {
      var v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
      var hc = document.getElementById('header-component');
      if (v && hc && getComputedStyle(hc).position === 'sticky') h = v;
    }
    return Math.round(h);
  }

  function initHero(wrap) {
    if (wrap.dataset.stkInit) return;
    wrap.dataset.stkInit = '1';

    var hero = wrap.querySelector('[data-stk-hero-pin]');
    var base = wrap.querySelector('[data-stk-base]');
    var print = wrap.querySelector('[data-stk-print]');
    var word = wrap.querySelector('[data-stk-print-word]');
    var cta = wrap.querySelector('[data-stk-cta]');
    var hint = wrap.querySelector('[data-stk-scrollhint]');
    if (!hero || !base || !print) return;

    var travelPct = parseInt(wrap.dataset.travel || '80', 10) / 100;
    if (REDUCED) travelPct = 0;
    var geo = { startY: 0, headerH: 0 };

    function layout() {
      var headerH = stickyHeaderHeight();
      var vh = window.innerHeight;
      var H = Math.max(480, vh - headerH);
      geo.headerH = headerH;
      hero.style.top = headerH + 'px';
      hero.style.height = H + 'px';
      wrap.style.height = Math.round(H + vh * travelPct) + 'px';

      var w = hero.clientWidth;
      var h = H;
      var portrait = h > w * 1.05;
      var cover = Math.max(w / IMG.w, h / IMG.h);
      var limit = portrait ? (w * 0.82) / (IMG.w * IMG.sw) : (h * 0.56) / (IMG.h * IMG.sh);
      var scale = Math.min(cover, limit);
      var fit = scale < cover - 0.0001;

      var iw = IMG.w * scale;
      var ih = IMG.h * scale;
      var ox = (w - iw) / 2;
      var oy = (h - ih) / 2;
      base.style.backgroundSize = iw + 'px ' + ih + 'px';
      base.style.backgroundPosition = ox + 'px ' + oy + 'px';
      if (fit) {
        base.style.webkitMaskSize = iw + 'px ' + ih + 'px';
        base.style.maskSize = iw + 'px ' + ih + 'px';
        base.style.webkitMaskPosition = ox + 'px ' + oy + 'px';
        base.style.maskPosition = ox + 'px ' + oy + 'px';
      } else {
        base.style.webkitMaskSize = '';
        base.style.maskSize = '';
        base.style.webkitMaskPosition = '';
        base.style.maskPosition = '';
      }
      var stW = iw * IMG.sw;
      var cx = ox + iw * (IMG.sx + IMG.sw * 0.47);
      var cy = oy + ih * (IMG.sy + IMG.sh * 0.51);
      var size = stW * 0.54;
      print.style.width = size + 'px';
      print.style.height = size + 'px';
      print.style.left = cx - size / 2 + 'px';
      print.style.top = cy - size / 2 + 'px';
      if (word) word.style.fontSize = size * 0.19 + 'px';
      geo.startY = h - (cy - size / 2) + size * 0.2;
      hero.classList.toggle('is-fit', fit);
      hero.classList.toggle('is-portrait', portrait);
      update();
    }

    /* Avanzamento calcolato dalla posizione sullo schermo: funziona sia se scorre la pagina
       sia se scorre un contenitore del tema (Horizon su desktop usa .page-wrapper). */
    function update() {
      var travel = wrap.offsetHeight - hero.offsetHeight;
      var top = wrap.getBoundingClientRect().top;
      var p = travel > 0 ? clamp((geo.headerH - top) / travel, 0, 1) : 1;
      if (REDUCED) p = 1;
      var e = 1 - Math.pow(1 - p, 3);
      print.style.transform = 'translate(0px, ' + geo.startY * (1 - e) + 'px) scale(' + (1.22 - 0.22 * e) + ') rotate(' + (-10 * (1 - e)) + 'deg)';
      print.style.opacity = clamp(p * 4, 0, 1);
      print.classList.toggle('is-landed', p >= 0.98);
      if (cta) cta.classList.toggle('is-on', p >= 0.85);
      if (hint) hint.style.opacity = clamp(1 - p * 4, 0, 1);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }

    layout();
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', layout);
    window.addEventListener('orientationchange', layout);
    window.addEventListener('load', layout);
    setTimeout(layout, 400);
    setTimeout(layout, 1500);
  }

  /* ================= CARD FORME ================= */
  function initCards() {
    var cards = document.querySelectorAll('.stk-card:not([data-stk-init])');
    if (!cards.length) return;
    Array.prototype.forEach.call(cards, function (c) { c.dataset.stkInit = '1'; });
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(cards, function (c) { c.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en, i) {
        if (!en.isIntersecting) return;
        var el = en.target;
        setTimeout(function () { el.classList.add('is-in'); }, i * 80);
        io.unobserve(el);
      });
    }, { threshold: 0.15 });
    Array.prototype.forEach.call(cards, function (c) { io.observe(c); });
  }

  /* ================= CONFIGURATORE ================= */
  var SHAPES = {
    rotondo:      { label: 'Rotondo',      ratio: 1,    radius: '50%', cut: 'ellipse' },
    quadrato:     { label: 'Quadrato',     ratio: 1,    radius: '10%', cut: 'rect' },
    rettangolare: { label: 'Rettangolare', ratio: 1.6,  radius: '6%',  cut: 'rect' },
    ovale:        { label: 'Ovale',        ratio: 1.55, radius: '50%', cut: 'ellipse' },
    sagomato:     { label: 'Sagomato',     ratio: 1.15, radius: '38% 62% 55% 45% / 45% 38% 62% 55%', cut: 'blob' }
  };
  var BLOB = 'M 50 3 C 77 3 97 22 97 50 C 97 79 73 97 48 97 C 23 97 3 76 3 49 C 3 23 23 3 50 3 Z';
  var IMG_EXT = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'heic', 'heif', 'bmp', 'avif'];
  var CARD_CM = 8.55;
  var HANDLE_ICON = '<svg viewBox="0 0 24 24"><path d="M4 14v6h6M20 10V4h-6M20 4l-6 6M4 20l6-6"/></svg>';

  function euro(cents) {
    try {
      return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' EUR';
    }
  }

  function isImageFile(f) {
    if (f.type && f.type.indexOf('image/') === 0) return true;
    var ext = String(f.name || '').toLowerCase().split('.').pop();
    return IMG_EXT.indexOf(ext) > -1;
  }

  function freshAdj() { return { x: 0, y: 0, s: 1, r: 0 }; }
  function adjText(a) {
    return 'posizione ' + Math.round(a.x) + '% / ' + Math.round(a.y) + '%, scala ' + Math.round(a.s * 100) + '%, rotazione ' + Math.round(a.r) + ' gradi';
  }

  function initConf(root) {
    if (root.dataset.stkInit) return;
    root.dataset.stkInit = '1';

    var DATA;
    try {
      DATA = JSON.parse(root.querySelector('[data-stk-products]').textContent);
    } catch (e) {
      return;
    }
    Object.keys(DATA).forEach(function (k) {
      if (!DATA[k].variants || !DATA[k].variants.length) {
        delete DATA[k];
        return;
      }
      DATA[k].variants.sort(function (a, b) { return a.cm - b.cm; });
    });
    if (!Object.keys(DATA).length) return;

    var wanted = '';
    try {
      wanted = new URLSearchParams(window.location.search).get('forma') || '';
    } catch (e) {
      wanted = '';
    }

    var state = {
      shape: DATA[wanted] ? wanted : (DATA.rotondo ? 'rotondo' : Object.keys(DATA)[0]),
      idx: 3,
      packs: 1,
      hasFile: false,
      imgUrl: '',
      imgRatio: 0,
      text: '',
      font: "'Nunito', sans-serif",
      color: '#2c2b29',
      align: 'center',
      adj: { img: freshAdj(), txt: freshAdj() },
      active: 'img'
    };

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var el = {
      stage: q('[data-stk-stage]'),
      box: q('[data-stk-box]'),
      sticker: q('[data-stk-sticker]'),
      img: q('[data-stk-img]'),
      txt: q('[data-stk-txt]'),
      cut: q('[data-stk-cut]'),
      empty: q('[data-stk-empty]'),
      tip: q('[data-stk-tip]'),
      scaleSticker: q('[data-stk-scale-sticker]'),
      scaleLbl: q('[data-stk-scale-lbl]'),
      scaleCard: q('[data-stk-scale-card]'),
      sizeVal: q('[data-stk-size-value]'),
      range: q('[data-stk-range]'),
      quick: qa('[data-stk-quick]'),
      shapeBtn: qa('[data-stk-shape]'),
      file: q('[data-stk-file]'),
      drop: q('[data-stk-drop]'),
      fileRow: q('[data-stk-filerow]'),
      fileName: q('[data-stk-filename]'),
      fileThumb: q('[data-stk-thumb]'),
      fileDel: q('[data-stk-filedel]'),
      textIn: q('[data-stk-text]'),
      fontIn: q('[data-stk-font]'),
      alignIn: qa('[data-stk-align]'),
      sw: qa('[data-stk-sw]'),
      adjBoxes: qa('[data-stk-adj]'),
      price: q('[data-stk-price]'),
      unit: q('[data-stk-unit]'),
      qty: q('[data-stk-qty]'),
      packLbl: q('[data-stk-packlabel]'),
      add: q('[data-stk-add]'),
      prev: q('[data-stk-prev]'),
      hint: q('[data-stk-hint]'),
      vid: q('[data-stk-variant]'),
      pShape: q('[data-stk-p-shape]'),
      pSize: q('[data-stk-p-size]'),
      pText: q('[data-stk-p-text]'),
      pFont: q('[data-stk-p-font]'),
      pColor: q('[data-stk-p-color]'),
      pImgAdj: q('[data-stk-p-imgadj]'),
      pTxtAdj: q('[data-stk-p-txtadj]'),
      previewFile: q('[data-stk-preview-file]'),
      reset: q('[data-stk-reset]'),
      form: q('[data-stk-form]')
    };
    var EMPTY_TXT = el.empty ? el.empty.innerHTML : '';

    var sel = document.createElement('div');
    sel.className = 'stk-sel';
    ['tl', 'tr', 'bl', 'br'].forEach(function (c) {
      var h = document.createElement('div');
      h.className = 'stk-sel__h';
      h.setAttribute('data-c', c);
      h.setAttribute('title', 'Trascina per ingrandire e ruotare');
      h.innerHTML = HANDLE_ICON;
      sel.appendChild(h);
    });
    el.box.appendChild(sel);
    var handles = Array.prototype.slice.call(sel.querySelectorAll('.stk-sel__h'));

    el.shapeBtn.forEach(function (b) {
      if (!DATA[b.dataset.stkShape]) b.style.display = 'none';
    });

    function variants() { return DATA[state.shape].variants; }
    function variant() {
      var v = variants();
      return v[Math.min(state.idx, v.length - 1)];
    }
    function ratio() {
      var s = SHAPES[state.shape];
      if (s.ratio === 1) return 1;
      if (state.imgRatio) return Math.max(0.4, Math.min(3, state.imgRatio));
      return s.ratio;
    }
    function indexOfCm(cm) {
      var v = variants();
      for (var i = 0; i < v.length; i++) if (v[i].cm === cm) return i;
      return -1;
    }
    function fontName() {
      return state.font.indexOf('Nunito') > -1 ? 'Nunito'
        : state.font.indexOf('Caveat') > -1 ? 'Caveat'
        : state.font.indexOf('Playfair') > -1 ? 'Playfair Display'
        : 'Inter';
    }
    function stickerSize() {
      var side = Math.min(el.box.clientWidth, el.box.clientHeight) || 320;
      var long = side * 0.8;
      var r = ratio();
      var w = long;
      var h = long / r;
      if (r < 1) { h = long; w = long * r; }
      return { w: w, h: h, long: long, r: r };
    }
    function activeLayerExists() {
      return state.active === 'img' ? !!state.imgUrl : !!state.text;
    }

    function showPreview() {
      if (!el.stage) return;
      var top = el.stage.getBoundingClientRect().top + (window.pageYOffset || 0) - 90;
      try {
        window.scrollTo({ top: top, behavior: 'smooth' });
      } catch (e) {
        window.scrollTo(0, top);
      }
      try { el.stage.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e2) { /* ignore */ }
    }

    function drawCut(w, h) {
      var s = SHAPES[state.shape];
      var inner;
      if (s.cut === 'ellipse') {
        inner = '<ellipse data-cut cx="50" cy="50" rx="48.5" ry="48.5" />';
      } else if (s.cut === 'rect') {
        inner = '<rect data-cut x="1.5" y="1.5" width="97" height="97" rx="' + (state.shape === 'quadrato' ? 10 : 6) + '" />';
      } else {
        inner = '<path data-cut d="' + BLOB + '" />';
      }
      el.cut.style.width = w + 16 + 'px';
      el.cut.style.height = h + 16 + 'px';
      el.cut.innerHTML = '<svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">' + inner + '</svg>';
    }

    function drawScale(cm, r) {
      if (!el.scaleSticker || !el.scaleCard) return;
      var avail = (el.stage ? el.stage.clientWidth : 320) - 80;
      var pxPerCm = avail / (cm + CARD_CM);
      var longSide = cm * pxPerCm;
      if (longSide > 120) { pxPerCm = 120 / cm; longSide = 120; }
      var sw = longSide;
      var sh = longSide / r;
      if (r < 1) { sh = longSide; sw = longSide * r; }
      el.scaleSticker.style.width = Math.max(6, sw) + 'px';
      el.scaleSticker.style.height = Math.max(6, sh) + 'px';
      el.scaleSticker.style.borderRadius = SHAPES[state.shape].radius;
      var cw = CARD_CM * pxPerCm;
      el.scaleCard.style.width = Math.max(8, cw) + 'px';
      el.scaleCard.style.height = Math.max(5, cw * 0.63) + 'px';
      if (el.scaleLbl) el.scaleLbl.textContent = cm + ' cm';
    }

    function transformOf(a, w) {
      return 'translate(' + (a.x / 100) * w + 'px, ' + (a.y / 100) * w + 'px) rotate(' + a.r + 'deg) scale(' + a.s + ')';
    }

    function drawSel(w) {
      var on = !!(state.imgUrl || state.text) && activeLayerExists();
      sel.classList.toggle('is-on', on);
      if (!on) return;
      var a = state.adj[state.active];
      if (state.active === 'img') {
        sel.style.left = el.sticker.offsetLeft + 'px';
        sel.style.top = el.sticker.offsetTop + 'px';
        sel.style.width = el.sticker.offsetWidth + 'px';
        sel.style.height = el.sticker.offsetHeight + 'px';
        sel.style.transform = 'translate(' + (a.x / 100) * w + 'px, ' + (a.y / 100) * w + 'px) rotate(' + a.r + 'deg)';
      } else {
        sel.style.left = el.sticker.offsetLeft + el.txt.offsetLeft + 'px';
        sel.style.top = el.sticker.offsetTop + el.txt.offsetTop + 'px';
        sel.style.width = el.txt.offsetWidth + 'px';
        sel.style.height = el.txt.offsetHeight + 'px';
        sel.style.transform = transformOf(a, w);
      }
    }

    function syncAdj() {
      el.adjBoxes.forEach(function (box) {
        var layer = box.dataset.stkAdj;
        var a = state.adj[layer];
        var has = layer === 'img' ? !!state.imgUrl : !!state.text;
        box.hidden = !has;
        var s = box.querySelector('[data-stk-adj-s]');
        var r = box.querySelector('[data-stk-adj-r]');
        var x = box.querySelector('[data-stk-adj-x]');
        var y = box.querySelector('[data-stk-adj-y]');
        if (s) { s.value = Math.round(a.s * 100); box.querySelector('[data-stk-adj-sv]').textContent = Math.round(a.s * 100) + '%'; }
        if (r) { r.value = Math.round(a.r); box.querySelector('[data-stk-adj-rv]').textContent = Math.round(a.r) + '°'; }
        if (x) { x.value = Math.round(a.x); box.querySelector('[data-stk-adj-xv]').textContent = Math.round(a.x); }
        if (y) { y.value = Math.round(a.y); box.querySelector('[data-stk-adj-yv]').textContent = Math.round(a.y); }
      });
    }

    function render() {
      var v = variant();
      var cm = v.cm;
      var sz = stickerSize();
      var w = sz.w, h = sz.h, long = sz.long, r = sz.r;

      el.sticker.style.width = w + 'px';
      el.sticker.style.height = h + 'px';
      el.sticker.style.borderRadius = SHAPES[state.shape].radius;
      drawCut(w, h);
      drawScale(cm, r);

      if (state.imgUrl) {
        if (el.img.getAttribute('src') !== state.imgUrl) el.img.src = state.imgUrl;
        el.img.style.display = 'block';
        el.img.style.transform = transformOf(state.adj.img, w);
      } else {
        el.img.removeAttribute('src');
        el.img.style.display = 'none';
      }
      el.txt.textContent = state.text;
      el.txt.style.fontFamily = state.font;
      el.txt.style.color = state.color;
      el.txt.style.textAlign = state.align;
      el.txt.style.fontWeight = state.font.indexOf('Nunito') > -1 ? 900 : 700;
      el.txt.style.fontSize = Math.max(12, long * 0.13) + 'px';
      el.txt.style.display = state.text ? 'block' : 'none';
      el.txt.style.transform = transformOf(state.adj.txt, w);

      if (!activeLayerExists()) state.active = state.imgUrl ? 'img' : 'txt';
      drawSel(w);

      var showEmpty = !(state.imgUrl || state.text);
      el.empty.style.display = showEmpty ? 'flex' : 'none';
      el.empty.innerHTML = state.hasFile && !state.imgUrl
        ? "File caricato. Per questo formato l'anteprima non è disponibile, ma il file viene allegato all'ordine."
        : EMPTY_TXT;
      if (el.tip) el.tip.hidden = showEmpty;

      el.sizeVal.textContent = cm + ' cm';

      var tot = v.price * state.packs;
      el.price.textContent = euro(tot);
      el.unit.textContent = euro(v.price) + ' per pacchetto da 100 pz - IVA inclusa';
      el.qty.textContent = state.packs;
      el.packLbl.textContent = 'Totale: ' + state.packs * 100 + ' adesivi';

      el.vid.value = v.id;
      el.form.querySelector('[name="quantity"]').value = state.packs;
      el.pShape.value = SHAPES[state.shape].label;
      el.pSize.value = cm + ' cm';
      el.pText.value = state.text;
      el.pText.disabled = !state.text;
      el.pFont.value = fontName();
      el.pFont.disabled = !state.text;
      el.pColor.value = state.color;
      el.pColor.disabled = !state.text;
      if (el.pImgAdj) { el.pImgAdj.value = adjText(state.adj.img); el.pImgAdj.disabled = !state.imgUrl; }
      if (el.pTxtAdj) { el.pTxtAdj.value = adjText(state.adj.txt); el.pTxtAdj.disabled = !state.text; }

      var ok = !!(state.hasFile || state.text);
      el.add.disabled = !ok;
      el.hint.textContent = ok
        ? "Il file che carichi e l'anteprima del ritaglio vengono allegati all'ordine."
        : "Carica un'immagine o aggiungi del testo per continuare.";

      el.shapeBtn.forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.stkShape === state.shape ? 'true' : 'false');
      });
      el.sw.forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.stkSw === state.color ? 'true' : 'false');
      });
      el.alignIn.forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.stkAlign === state.align ? 'true' : 'false');
      });
      el.quick.forEach(function (b) {
        b.setAttribute('aria-pressed', parseInt(b.dataset.stkQuick, 10) === cm ? 'true' : 'false');
      });
      syncAdj();
    }

    /* ---------- box regolazioni (slider) ---------- */
    el.adjBoxes.forEach(function (box) {
      var layer = box.dataset.stkAdj;
      function bind(selr, fn) {
        var input = box.querySelector(selr);
        if (!input) return;
        input.addEventListener('input', function () {
          state.active = layer;
          fn(parseFloat(input.value));
          render();
        });
      }
      bind('[data-stk-adj-s]', function (v) { state.adj[layer].s = clamp(v / 100, 0.3, 3); });
      bind('[data-stk-adj-r]', function (v) { state.adj[layer].r = clamp(v, -180, 180); });
      bind('[data-stk-adj-x]', function (v) { state.adj[layer].x = clamp(v, -100, 100); });
      bind('[data-stk-adj-y]', function (v) { state.adj[layer].y = clamp(v, -100, 100); });
      var rst = box.querySelector('[data-stk-adj-reset]');
      if (rst) {
        rst.addEventListener('click', function (e) {
          e.preventDefault();
          state.adj[layer] = freshAdj();
          state.active = layer;
          render();
        });
      }
    });

    /* ---------- trascina / pizzica / rotella sull'anteprima ---------- */
    var pointers = {};
    var gesture = null;

    function layerAt(target) {
      if (state.text && (target === el.txt || el.txt.contains(target))) return 'txt';
      if (state.imgUrl) return 'img';
      if (state.text) return 'txt';
      return null;
    }
    function pointerList() {
      return Object.keys(pointers).map(function (k) { return pointers[k]; });
    }
    function normDeg(d) {
      while (d > 180) d -= 360;
      while (d < -180) d += 360;
      return d;
    }

    el.sticker.addEventListener('pointerdown', function (e) {
      var layer = layerAt(e.target);
      if (!layer) return;
      e.preventDefault();
      try { el.sticker.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      state.active = layer;
      var list = pointerList();
      var a = state.adj[layer];
      if (list.length === 1) {
        gesture = { type: 'move', layer: layer, x0: e.clientX, y0: e.clientY, ax: a.x, ay: a.y };
      } else if (list.length >= 2) {
        var dx = list[1].x - list[0].x;
        var dy = list[1].y - list[0].y;
        gesture = {
          type: 'pinch', layer: layer,
          d0: Math.sqrt(dx * dx + dy * dy) || 1,
          a0: Math.atan2(dy, dx) * 180 / Math.PI,
          s0: a.s, r0: a.r
        };
      }
      el.sticker.classList.add('is-dragging');
      render();
    });

    el.sticker.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId] || !gesture) return;
      e.preventDefault();
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var a = state.adj[gesture.layer];
      var w = stickerSize().w;
      if (gesture.type === 'move') {
        a.x = clamp(gesture.ax + ((e.clientX - gesture.x0) / w) * 100, -100, 100);
        a.y = clamp(gesture.ay + ((e.clientY - gesture.y0) / w) * 100, -100, 100);
      } else {
        var list = pointerList();
        if (list.length < 2) return;
        var dx = list[1].x - list[0].x;
        var dy = list[1].y - list[0].y;
        var d = Math.sqrt(dx * dx + dy * dy) || 1;
        var ang = Math.atan2(dy, dx) * 180 / Math.PI;
        a.s = clamp(gesture.s0 * (d / gesture.d0), 0.3, 3);
        a.r = clamp(normDeg(gesture.r0 + (ang - gesture.a0)), -180, 180);
      }
      render();
    });

    function endPointer(e) {
      delete pointers[e.pointerId];
      var list = pointerList();
      if (!list.length) {
        gesture = null;
        el.sticker.classList.remove('is-dragging');
      } else if (list.length === 1 && gesture) {
        var a = state.adj[gesture.layer];
        gesture = { type: 'move', layer: gesture.layer, x0: list[0].x, y0: list[0].y, ax: a.x, ay: a.y };
      }
    }
    el.sticker.addEventListener('pointerup', endPointer);
    el.sticker.addEventListener('pointercancel', endPointer);
    el.sticker.addEventListener('lostpointercapture', endPointer);

    el.sticker.addEventListener('wheel', function (e) {
      var layer = layerAt(e.target);
      if (!layer) return;
      e.preventDefault();
      state.active = layer;
      var a = state.adj[layer];
      if (e.shiftKey) {
        a.r = clamp(a.r + (e.deltaY > 0 ? 3 : -3), -180, 180);
      } else {
        a.s = clamp(a.s * (e.deltaY > 0 ? 0.95 : 1.05), 0.3, 3);
      }
      render();
    }, { passive: false });

    /* ---------- maniglie agli angoli: ingrandisci (proporzionale) e ruota ---------- */
    var hg = null;
    handles.forEach(function (hd) {
      hd.addEventListener('pointerdown', function (e) {
        if (!activeLayerExists()) return;
        e.preventDefault();
        e.stopPropagation();
        try { hd.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        var rect = sel.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var dx = e.clientX - cx;
        var dy = e.clientY - cy;
        var a = state.adj[state.active];
        hg = {
          id: e.pointerId, layer: state.active, cx: cx, cy: cy,
          d0: Math.sqrt(dx * dx + dy * dy) || 1,
          a0: Math.atan2(dy, dx) * 180 / Math.PI,
          s0: a.s, r0: a.r
        };
        el.sticker.classList.add('is-dragging');
      });
      hd.addEventListener('pointermove', function (e) {
        if (!hg || hg.id !== e.pointerId) return;
        e.preventDefault();
        var dx = e.clientX - hg.cx;
        var dy = e.clientY - hg.cy;
        var d = Math.sqrt(dx * dx + dy * dy) || 1;
        var ang = Math.atan2(dy, dx) * 180 / Math.PI;
        var a = state.adj[hg.layer];
        a.s = clamp(hg.s0 * (d / hg.d0), 0.3, 3);
        a.r = clamp(normDeg(hg.r0 + (ang - hg.a0)), -180, 180);
        render();
      });
      function endH(e) {
        if (!hg || hg.id !== e.pointerId) return;
        hg = null;
        el.sticker.classList.remove('is-dragging');
      }
      hd.addEventListener('pointerup', endH);
      hd.addEventListener('pointercancel', endH);
      hd.addEventListener('lostpointercapture', endH);
    });

    /* ---------- anteprima PNG del ritaglio, allegata all'ordine ---------- */
    function buildPreview() {
      return new Promise(function (resolve, reject) {
        try {
          var r = ratio();
          var W = 1200;
          var H = Math.round(W / r);
          if (r < 1) { H = 1200; W = Math.round(1200 * r); }
          var c = document.createElement('canvas');
          c.width = W;
          c.height = H;
          var ctx = c.getContext('2d');
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, W, H);

          ctx.save();
          ctx.beginPath();
          var cut = SHAPES[state.shape].cut;
          if (cut === 'ellipse') {
            ctx.ellipse(W / 2, H / 2, W / 2, H / 2, 0, 0, Math.PI * 2);
            ctx.clip();
          } else if (cut === 'rect') {
            var rad = (state.shape === 'quadrato' ? 0.1 : 0.06) * Math.min(W, H);
            ctx.moveTo(rad, 0);
            ctx.arcTo(W, 0, W, H, rad);
            ctx.arcTo(W, H, 0, H, rad);
            ctx.arcTo(0, H, 0, 0, rad);
            ctx.arcTo(0, 0, W, 0, rad);
            ctx.clip();
          } else {
            var p = new Path2D(BLOB);
            ctx.scale(W / 100, H / 100);
            ctx.clip(p);
            ctx.setTransform(1, 0, 0, 1, 0, 0);
          }

          var long = Math.max(W, H);

          if (state.imgUrl && el.img.complete && el.img.naturalWidth) {
            var iw = el.img.naturalWidth, ih = el.img.naturalHeight;
            var sc = Math.max(W / iw, H / ih);
            var dw = iw * sc, dh = ih * sc;
            var a = state.adj.img;
            ctx.save();
            ctx.translate(W / 2 + (a.x / 100) * W, H / 2 + (a.y / 100) * W);
            ctx.rotate((a.r * Math.PI) / 180);
            ctx.scale(a.s, a.s);
            ctx.drawImage(el.img, -dw / 2, -dh / 2, dw, dh);
            ctx.restore();
          }

          if (state.text) {
            var t = state.adj.txt;
            var fs = long * 0.13;
            ctx.save();
            ctx.translate(W / 2 + (t.x / 100) * W, H / 2 + (t.y / 100) * W);
            ctx.rotate((t.r * Math.PI) / 180);
            ctx.scale(t.s, t.s);
            ctx.font = (state.font.indexOf('Nunito') > -1 ? '900 ' : '700 ') + fs + 'px ' + state.font;
            ctx.fillStyle = state.color;
            ctx.textBaseline = 'middle';
            ctx.textAlign = state.align === 'left' ? 'left' : state.align === 'right' ? 'right' : 'center';
            var maxW = W * 0.84;
            var words = state.text.split(' ');
            var lines = [];
            var line = '';
            words.forEach(function (wd) {
              var test = line ? line + ' ' + wd : wd;
              if (ctx.measureText(test).width > maxW && line) {
                lines.push(line);
                line = wd;
              } else {
                line = test;
              }
            });
            if (line) lines.push(line);
            var lh = fs * 1.15;
            var y0 = -((lines.length - 1) * lh) / 2;
            var x0 = state.align === 'left' ? -W / 2 + W * 0.08 : state.align === 'right' ? W / 2 - W * 0.08 : 0;
            lines.forEach(function (ln, i) { ctx.fillText(ln, x0, y0 + i * lh); });
            ctx.restore();
          }
          ctx.restore();

          c.toBlob(function (blob) {
            if (!blob) return reject(new Error('no blob'));
            resolve(new File([blob], 'anteprima-ritaglio.png', { type: 'image/png' }));
          }, 'image/png');
        } catch (err) {
          reject(err);
        }
      });
    }

    el.form.addEventListener('submit', function (e) {
      if (!el.previewFile || el.form.dataset.stkReady === '1') return;
      if (!(state.imgUrl || state.text)) return;
      e.preventDefault();
      var done = false;
      function go() {
        if (done) return;
        done = true;
        el.form.dataset.stkReady = '1';
        el.form.submit();
      }
      setTimeout(go, 2500);
      buildPreview().then(function (file) {
        try {
          var dt = new DataTransfer();
          dt.items.add(file);
          el.previewFile.files = dt.files;
        } catch (err) { /* senza DataTransfer si procede senza anteprima */ }
        go();
      }).catch(go);
    });

    /* ---------- misura ---------- */
    var i5 = indexOfCm(5);
    if (i5 > -1) state.idx = i5;

    el.shapeBtn.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var cm = variant().cm;
        state.shape = b.dataset.stkShape;
        var ni = indexOfCm(cm);
        state.idx = ni > -1 ? ni : Math.min(state.idx, variants().length - 1);
        el.range.max = variants().length - 1;
        el.range.value = state.idx;
        render();
      });
    });

    el.range.max = variants().length - 1;
    el.range.value = state.idx;
    el.range.addEventListener('input', function () {
      state.idx = parseInt(el.range.value, 10);
      render();
    });
    el.range.addEventListener('change', function () {
      state.idx = parseInt(el.range.value, 10);
      render();
    });
    el.quick.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var ni = indexOfCm(parseInt(b.dataset.stkQuick, 10));
        if (ni > -1) state.idx = ni;
        el.range.value = state.idx;
        render();
      });
    });

    /* ---------- immagine ---------- */
    function loadFile(f) {
      if (!f) return;
      state.hasFile = true;
      state.imgUrl = '';
      state.imgRatio = 0;
      state.adj.img = freshAdj();
      el.fileName.textContent = f.name;
      el.fileRow.classList.add('is-on');
      el.fileThumb.style.display = 'none';
      render();

      if (!isImageFile(f)) {
        if (isSmall()) showPreview();
        return;
      }

      var url;
      try {
        url = URL.createObjectURL(f);
      } catch (e) {
        return;
      }
      var probe = new Image();
      probe.onload = function () {
        state.imgUrl = url;
        state.imgRatio = probe.naturalWidth / probe.naturalHeight;
        state.active = 'img';
        el.fileThumb.src = url;
        el.fileThumb.style.display = 'block';
        render();
        el.img.onload = function () { render(); };
        if (isSmall()) showPreview();
      };
      probe.onerror = function () {
        state.imgUrl = '';
        render();
        if (isSmall()) showPreview();
      };
      probe.src = url;
    }

    el.file.addEventListener('change', function () { loadFile(el.file.files[0]); });
    ['dragenter', 'dragover'].forEach(function (t) {
      el.drop.addEventListener(t, function (e) { e.preventDefault(); el.drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (t) {
      el.drop.addEventListener(t, function (e) { e.preventDefault(); el.drop.classList.remove('is-over'); });
    });
    el.drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files.length) {
        try { el.file.files = e.dataTransfer.files; } catch (err) { /* ignore */ }
        loadFile(e.dataTransfer.files[0]);
      }
    });
    el.fileDel.addEventListener('click', function (e) {
      e.preventDefault();
      el.file.value = '';
      state.hasFile = false;
      state.imgUrl = '';
      state.imgRatio = 0;
      state.adj.img = freshAdj();
      el.fileRow.classList.remove('is-on');
      render();
    });

    /* ---------- testo ---------- */
    el.textIn.addEventListener('input', function () {
      var had = !!state.text;
      state.text = el.textIn.value.slice(0, 60);
      if (!had && state.text) state.active = 'txt';
      render();
    });
    el.fontIn.addEventListener('change', function () {
      state.font = el.fontIn.value;
      render();
    });
    el.sw.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); state.color = b.dataset.stkSw; render(); });
    });
    el.alignIn.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); state.align = b.dataset.stkAlign; render(); });
    });

    /* ---------- pacchetti / varie ---------- */
    q('[data-stk-minus]').addEventListener('click', function (e) {
      e.preventDefault();
      state.packs = Math.max(1, state.packs - 1);
      render();
    });
    q('[data-stk-plus]').addEventListener('click', function (e) {
      e.preventDefault();
      state.packs = Math.min(99, state.packs + 1);
      render();
    });

    if (el.prev) {
      el.prev.addEventListener('click', function (e) {
        e.preventDefault();
        showPreview();
      });
    }

    el.reset.addEventListener('click', function (e) {
      e.preventDefault();
      el.file.value = '';
      el.textIn.value = '';
      state.hasFile = false;
      state.imgUrl = '';
      state.imgRatio = 0;
      state.text = '';
      state.packs = 1;
      state.adj = { img: freshAdj(), txt: freshAdj() };
      el.fileRow.classList.remove('is-on');
      render();
    });

    window.addEventListener('resize', render);
    render();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(render).catch(function () {});
    }
  }

  /* ================= AVVIO ================= */
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-stk-hero]'), initHero);
    initCards();
    Array.prototype.forEach.call(document.querySelectorAll('[data-stk-conf]'), initConf);
  }

  if (!window.__stklyObserver) {
    window.__stklyObserver = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    window.addEventListener('pageshow', boot);
    document.addEventListener('shopify:section:load', boot);

    if ('MutationObserver' in window) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () { pending = null; boot(); }, 60);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  } else {
    boot();
  }
})();